<template>
  <div class="wrapper">
    <v-layout v-if="showStatistics" column>
      <v-flex class="title-screen" xs12>
        <span>{{ adminText('workflowsAll.ticket_statistics_21dec81', 'Ticket statistics') }}</span>
      </v-flex>
      <div class="select-inputs">
        <v-select
          v-if="showStatistics"
          v-model="performanceSelectModel"
          :items="workflowUi(performancesSelectData)"
          :item-text="item => workflowPerformanceOption(item)"
          item-value="id"
          :label="adminText('workflowsAll.performances_c5453c0', 'Performances')"
          box
        />
        <v-select
          v-if="showStatistics"
          v-model="ticketSelectModel"
          :items="workflowUi(ticketSelectData)"
          :item-text="workflowStatsOption"
          item-value="id"
          :label="adminText('workflowsAll.ticket_types_b974d11', 'Ticket types')"
          box
        />
      </div>
      <div class="select-inputs">
        <v-select
          v-if="showStatistics"
          v-model="ticketSellerSelectModel"
          :items="workflowUi(ticketSellerSelectData)"
          :item-text="workflowStatsOption"
          item-value="id"
          :label="adminText('workflowsAll.sales_channels_07c6da3', 'Sales channels')"
          box
        />
        <v-select
          v-if="showStatistics && promoCodesSelectData.length"
          v-model="promoCodesSelectModel"
          :items="workflowUi(promoCodesSelectData)"
          :item-text="workflowStatsOption"
          item-value="id"
          :label="adminText('workflowsAll.promo_codes_2853dfe', 'Promo Codes')"
          box
          multiple
          @input="handleAllPromoCodesSelection"
        >
          <template v-slot:selection="{ item }">
            <span
              v-if="
                (selectedPromoCodeIds.includes(null) && item.id === null) ||
                  (!selectedPromoCodeIds.includes(null) && item.id !== null)
              "
              class="selection-promo-code-span"
            >{{ workflowStatsOption(item) }}</span>
          </template>
        </v-select>
        <v-select
          v-if="showStatistics && hasKulturnaIskaznicaOrders"
          v-model="kulturnaIskaznicaPaymentSelectModel"
          :items="workflowUi(kulturnaIskaznicaPaymentSelectData)"
          :item-text="workflowStatsOption"
          item-value="id"
          :label="adminText('workflowsAll.payment_type_f9fb949', 'Payment type')"
          box
        />
      </div>
      <div class="statistics-card-container">
        <div class="statistics-card">
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.total_visitors_6b30411', 'Total visitors') }}</span>
            <div class="total-sold-data">
              <span class="primary-data-style">{{ workflowLabel(totalVisitors) }}</span>
            </div>
          </div>
          <img
            src="/assets/pie-chart.svg"
            :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>

        <div class="statistics-card">
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.active_subscriptions_aed0b1b', 'Active subscriptions') }}</span>
            <div class="total-sold-data">
              <span class="primary-data-style">{{ workflowLabel(totalSubscriptions) }}</span>
            </div>
          </div>
          <img
            src="/assets/pie-chart.svg"
            :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>

        <div class="statistics-card" @click="handleTotalTicketsSoldClick">
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.total_tickets_sold_booked_890298c', 'Total tickets sold + Booked') }}</span>
            <div class="total-sold-data">
              <span class="primary-data-style">{{ workflowLabel(totalTicketsSold) }}</span>
              <span class="tertiary-large-data-style">+</span>
              <span class="secondary-data-style">{{ workflowLabel(totalTicketsReserved) }}</span>
              <span class="tertiary-small-data-style">/ {{ workflowLabel(totalTicketCount) }}</span>
            </div>
          </div>
          <img
            src="/assets/pie-chart.svg"
            :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>

        <div
          class="statistics-card"
          @click="showSoldTicketsWithPromoCodeModal = !showSoldTicketsWithPromoCodeModal"
        >
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.used_promocodes_49deee9', 'Used promocodes') }}</span>
            <div class="total-sold-data">
              <span class="primary-data-style">{{ workflowLabel(totalTicketsWithPromoSold) }}</span>
            </div>
          </div>
          <img
            src="/assets/pie-chart.svg"
            :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>

        <div class="statistics-card" @click="handleTotalEarningsClick">
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.total_earnings_0f37656', 'Total earnings') }}</span>
            <div class="total-earning-data">
              <span class="primary-data-style">{{ workflowLabel(totalEarnings) }} EUR</span>
            </div>
          </div>
          <img
            src="/assets/pie-chart.svg"
            :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>

        <div class="statistics-card" @click="handleCancelledTicketsClick">
          <div class="statistics-card-content">
            <span class="statistic-card-title">{{ adminText('workflowsAll.cancelled_tickets_95d54ed', 'Cancelled Tickets') }}</span>
            <span class="tertiary-data-style">{{ workflowLabel(totalRefundedTicketsCount) }}</span>
          </div>
          <img src="/assets/graph.svg" :alt="adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')" style="width: 1.5rem; height: 1.5rem">
        </div>
      </div>

      <div v-if="showStatistics" class="grid">
        <div class="grid full-width-row">
          <graph
            :title="adminText('workflowsAll.tickets_sold_by_day_b9b78fb', 'Tickets sold by day')"
            :has-data="statisticsLoading || ticketsSoldByDayChartData.labels.length !== 0"
            :data-filter="true"
            :initial-date-range-option="1"
            :date-filter-options="[1, 2, 3, 4]"
            :allow-all-time="true"
            :all-time-date-range="allTimeDateRange"
            :preset-end-date="statisticsPeriodEndDate"
            :header-total-label="totalTicketsSoldInSelectedRange"
            :start-date="startDate"
            :end-date="endDate"
            @changeDateRange="changeTotalTicketsDateRange($event)"
          >
            <div
              v-if="statisticsLoading"
              class="statistics-chart-skeleton statistics-chart-skeleton--tickets"
            >
              <vue-skeleton-loader rounded radius="8" width="35%" height="20px" animation="fade" />
              <vue-skeleton-loader rounded radius="8" width="100%" height="220px" animation="fade" />
            </div>
            <stacked-bar-chart
              v-else-if="ticketsSoldByDayChartData && ticketsSoldByDayChartData.labels.length"
              :data="workflowUi(ticketsSoldByDayChartData)"
              :options="workflowUi({
                stackedY: true,
                barThickness: 22,
                barPercentage: 100,
                barDistance: 25,
                onClick: handleBarClick,
                onHover: handleBarHover,
              })"
              :scrollable="true"
            />
            <div v-else class="noDataText">
              {{ adminText('workflowsAll.no_data_to_display_statistics_will_be_availab_e0ac8c7', 'No data to display. Statistics will be available when someone buys a ticket.') }}
            </div>
            <div v-if="!statisticsLoading && ticketsSoldByDayChartData.labels.length === 0">
              {{ adminText('workflowsAll.no_data_to_display_for_selected_time_period_7ec19bb', 'No data to display for selected time period') }}
            </div>
          </graph>
        </div>

        <div class="grid other-rows">
          <graph
            :title="adminText('workflowsAll.sold_and_available_tickets_636354d', 'Sold and available tickets')"
            :data-filter="false"
            :has-data="true"
            :value="``"
          >
            <pie-chart :data="workflowUi(soldAndAvailableChartData)" :options="workflowUi({ displayLegend: true })" />
          </graph>
          <graph
            :title="adminText('workflowsAll.heatmap_for_average_ticket_purchases_bc1f3de', 'Heatmap for average ticket purchases')"
            :data-filter="false"
            :has-data="true"
            :value="``"
            style="grid-row: span 2"
          >
            <heatmap
              :x-labels="heatmapXLabels"
              :y-labels="heatmapYLabels"
              :data="workflowUi(heatmapData)"
              :groups="heatmapGroups"
            />
          </graph>
          <graph :title="adminText('workflowsAll.daily_cumulative_revenue_00231ae', 'Daily cumulative revenue')" :data-filter="false" :has-data="true" :value="``">
            <div
              v-if="statisticsLoading"
              class="statistics-chart-skeleton statistics-chart-skeleton--line"
            >
              <vue-skeleton-loader rounded radius="8" width="35%" height="20px" animation="fade" />
              <vue-skeleton-loader rounded radius="8" width="100%" height="220px" animation="fade" />
            </div>
            <line-chart
              v-else-if="
                cumulativeTicketsRevenueChartData &&
                  cumulativeTicketsRevenueChartData.labels.length > 1
              "
              :data="workflowUi(cumulativeTicketsRevenueChartData)"
              :options="workflowUi({})"
            />
            <div v-else class="noDataText">
              <div v-if="cumulativeTicketsRevenueChartData.labels.length === 1">
                {{ adminText('workflowsAll.revenue_for_6d9510d', 'Revenue for') }}
                <b>
                  {{ workflowLabel(cumulativeTicketsRevenueChartData.labels[0]) }}:
                  {{ workflowLabel(cumulativeTicketsRevenueChartData.datasets[0].data[0]) }} EUR </b>. <br>
                {{ adminText('workflowsAll.more_data_will_be_displayed_tomorrow_8439250', 'More data will be displayed tomorrow.') }}
              </div>
              <div v-else>
                {{ adminText('workflowsAll.no_data_to_display_statistics_will_be_availab_e0ac8c7', 'No data to display. Statistics will be available when someone buys a ticket.') }}
              </div>
            </div>
          </graph>
        </div>
        <div class="grid full-width-row">
          <graph
            :title="adminText('workflowsAll.earnings_by_day_d113a53', 'Earnings by day')"
            :data-filter="true"
            :has-data="statisticsLoading || earningsChartData.labels.length !== 0"
            :value="``"
            :initial-date-range-option="1"
            :date-filter-options="[1, 2, 3, 4]"
            :allow-all-time="true"
            :all-time-date-range="allTimeDateRange"
            :preset-end-date="statisticsPeriodEndDate"
            :header-total-label="totalEarningsInSelectedRange"
            :start-date="startDate"
            :end-date="endDate"
            @changeDateRange="changeTotalTicketsDateRange($event)"
          >
            <div
              v-if="statisticsLoading"
              class="statistics-chart-skeleton statistics-chart-skeleton--earnings"
            >
              <vue-skeleton-loader rounded radius="8" width="35%" height="20px" animation="fade" />
              <vue-skeleton-loader rounded radius="8" width="100%" height="220px" animation="fade" />
            </div>
            <bar-chart
              v-else-if="earningsChartData && earningsChartData.labels.length"
              :data="workflowUi(earningsChartData)"
              :options="workflowUi({})"
              :scrollable="true"
            />
            <div v-else class="noDataText">
              {{ adminText('workflowsAll.no_data_to_display_statistics_will_be_availab_e0ac8c7', 'No data to display. Statistics will be available when someone buys a ticket.') }}
            </div>
            <div v-if="!statisticsLoading && earningsChartData.labels.length === 0">
              {{ adminText('workflowsAll.no_data_to_display_for_selected_time_period_7ec19bb', 'No data to display for selected time period') }}
            </div>
          </graph>
        </div>
        <div class="grid full-width-row">
          <graph :title="adminText('workflowsAll.ticket_sales_by_city_ea99615', 'Ticket sales by city')" :data-filter="false" :has-data="true" :value="``">
            <template v-if="showCitySales">
              <div class="city-sales-layout">
                <city-sales-map
                  :loading="cityMapLoading"
                  :error="cityMapError"
                  :points="cityMapPoints"
                />

                <div class="city-sales-chart-wrap">
                  <div v-if="cityMapLoading" class="city-sales-loading-state">
                    <spinner />
                    <div class="city-sales-loading-subtitle">{{ adminText('workflowsAll.city_sales_loading_b34dd68', 'City sales loading...') }}</div>
                  </div>
                  <div v-else-if="cityMapError" class="city-sales-loading-state">
                    <div class="city-sales-loading-subtitle">{{ workflowLabel(cityMapError) }}</div>
                  </div>
                  <div v-else-if="hasCitySalesData" class="city-sales-chart">
                    <bar-chart
                      :data="workflowUi(citySalesBarChartData)"
                      :options="workflowUi({ indexAxis: 'y', barThickness: 35 })"
                      background-color="#CEE4F2"
                    />
                  </div>
                  <div v-else class="noDataText city-sales-no-data">
                    {{ adminText('workflowsAll.no_city_sales_data_available_58bda99', 'No city sales data available.') }}
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="city-sales-placeholder">
              <main-button @click="loadCitySales">{{ adminText('workflowsAll.show_sales_557d819', 'Show sales') }}</main-button>
            </div>
          </graph>
        </div>
      </div>
    </v-layout>
    <v-layout v-else-if="statisticsLoading" column class="statistics-loading-layout">
      <v-flex class="title-screen" xs12>
        <span>{{ adminText('workflowsAll.ticket_statistics_21dec81', 'Ticket statistics') }}</span>
      </v-flex>
      <div class="select-inputs">
        <vue-skeleton-loader rounded radius="8" width="100%" height="56px" animation="fade" />
        <vue-skeleton-loader rounded radius="8" width="100%" height="56px" animation="fade" />
      </div>
      <div class="statistics-card-container statistics-card-container--loading">
        <vue-skeleton-loader rounded radius="16" width="100%" height="120px" animation="fade" />
        <vue-skeleton-loader rounded radius="16" width="100%" height="120px" animation="fade" />
        <vue-skeleton-loader rounded radius="16" width="100%" height="120px" animation="fade" />
      </div>
      <div class="statistics-chart-skeleton statistics-chart-skeleton--page">
        <vue-skeleton-loader rounded radius="8" width="25%" height="20px" animation="fade" />
        <vue-skeleton-loader rounded radius="8" width="100%" height="280px" animation="fade" />
      </div>
      <div class="statistics-chart-skeleton statistics-chart-skeleton--page">
        <vue-skeleton-loader rounded radius="8" width="25%" height="20px" animation="fade" />
        <vue-skeleton-loader rounded radius="8" width="100%" height="280px" animation="fade" />
      </div>
    </v-layout>
    <div v-else class="no-stats not-available">
      <h1>{{ adminText('workflowsAll.as_you_start_selling_tickets_your_statistics__4d7d252', 'As you start selling tickets, your statistics will appear here.') }}</h1>
    </div>
    <refunded-tickets-modal
      v-if="showRefundedTicketsModal"
      :event-id="eventId"
      :event-template-id="eventTemplateId"
      :event-to="eventTo"
      :total-refunded-tickets="totalRefundedTicketsCount"
      :order-item-id="selectedOrderItemId === null ? null : Number(selectedOrderItemId)"
      :ticket-seller-id="selectedTicketSellerId === null ? null : Number(selectedTicketSellerId)"
      :promo-code-ids="selectedPromoCodeIds.filter(id => id !== null)"
      :sale-channel-online="saleChannelOnline"
      @closeModal="showRefundedTicketsModal = !showRefundedTicketsModal"
    />
    <sold-tickets-modal
      v-if="soldTicketsModalData"
      :data="workflowUi(soldTicketsModalData)"
      :title="workflowLabel(soldTicketsModalTitle)"
      @closeModal="soldTicketsModalData = null"
    />
    <ticket-types-statistics-modal
      v-if="showTicketTypesStatisticsModal"
      :data="workflowUi(ticketTypesData)"
      :initial-selected-date="selectedTicketTypesDate"
      @closeModal="showTicketTypesStatisticsModal = !showTicketTypesStatisticsModal"
    />
    <sold-tickets-with-promo-code-modal
      v-if="showSoldTicketsWithPromoCodeModal"
      :data="workflowUi(soldTicketsByPromoCodeData)"
      :promo-codes="promoCodes"
      :total-sold="totalTicketsWithPromoSold"
      :total-count="totalTicketCountWithPromoCode"
      @closeModal="showSoldTicketsWithPromoCodeModal = !showSoldTicketsWithPromoCodeModal"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import {
  GET_PURCHASE_BY_EVENT_2,
  GET_PURCHASE_BY_EVENT_CITY_STATS,
} from '@/graphql/purchase.graphql'
import Graph from '../../components/shared/graphs/graph.vue'
import PieChart from '../../components/shared/graphs/pie-chart.vue'
import BarChart from '../../components/shared/graphs/bar-chart.vue'
import LineChart from '../../components/shared/graphs/line-chart.vue'
import StackedBarChart from '../../components/shared/graphs/stacked-bar-chart.vue'
import moment from 'moment'
import { exchangeRate, heatmapColorsArray } from '@/utils'
import { isEqual, round, sum } from 'lodash'
import RefundedTicketsModal from '@/components/stats/refunded-tickets-modal.vue'
import SoldTicketsModal from '@/components/stats/sold-tickets-modal.vue'
import TicketTypesStatisticsModal from '@/components/stats/ticket-types-statistics-modal.vue'
import Heatmap from '@/components/shared/graphs/heatmap.vue'
import SoldTicketsWithPromoCodeModal from '@/components/stats/sold-tickets-with-promo-code-modal.vue'
import CitySalesMap from '@/components/stats/city-sales-map.vue'
import sumBy from 'lodash/sumBy'

export default {
  mixins: [WorkflowDisplay],
  name: 'ticket-statistics-container',
  components: {
    SoldTicketsWithPromoCodeModal,
    Heatmap,
    TicketTypesStatisticsModal,
    SoldTicketsModal,
    RefundedTicketsModal,
    CitySalesMap,
    Graph,
    PieChart,
    BarChart,
    LineChart,
    StackedBarChart,
  },
  props: {
    eventId: String,
    eventTemplateId: String,
    user: Object,
  },
  data() {
    return {
      selectedEventId: null,
      ticketsSoldByDayChartData: null,
      soldAndAvailableChartData: null,
      earningsChartData: null,
      exchangeRate: exchangeRate,
      cumulativeTicketsRevenueChartData: null,
      statisticsLoading: true,
      showStatistics: false,
      totalEarnings: 0,
      totalTicketsSold: 0,
      totalTicketsReserved: 0,
      totalTicketCount: 0,
      totalVisitors: 0,
      totalSubscriptions: 0,
      totalRefundedTicketsCount: 0,
      ticketSelectData: [],
      promoCodes: [],
      saleChannelOnline: false,
      ticketSelectModel: {
        name: 'test',
        id: null,
      },
      performanceSelectModel: null,
      performancesSelectData: null,
      selectedOrderItemId: null,
      ticketSellerSelectData: [],
      ticketSellerSelectModel: {
        name: 'test',
        id: null,
      },
      selectedTicketSellerId: null,
      theaterTicketSellerUserId: null,
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      startDate: moment(new Date()).subtract(6, 'd').format('YYYY-MM-DD'),
      earningsEndDate: moment(new Date()).format('YYYY-MM-DD'),
      earningsStartDate: moment(new Date()).subtract(6, 'd').format('YYYY-MM-DD'),
      promoCodesSelectData: [],
      selectedPromoCodeIds: [],
      promoCodesSelectModel: [],
      showRefundedTicketsModal: false,
      eventTo: null,
      soldTicketsModalData: null,
      soldTicketsModalTitle: '',
      totalTicketsWithPromoSold: 0,
      totalTicketCountWithPromoCode: 0,
      salesPeriodStartDate: null,
      totalPromoCodeEarnings: 0,
      showTicketTypesStatisticsModal: false,
      ticketTypesData: null,
      selectedTicketTypesDate: null,
      heatmapData: [],
      heatmapXLabels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      heatmapYLabels: [
        '00:00 - 07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ],
      heatmapGroups: [],
      showSoldTicketsWithPromoCodeModal: false,
      soldTicketsByPromoCodeData: [],
      ticketsSoldByCityData: [],
      showCitySales: false,
      cityMapLoading: false,
      cityMapError: '',
      cityMapPoints: [],
      hasKulturnaIskaznicaOrders: false,
      kulturnaIskaznicaPaymentSelectModel: 'all',
      kulturnaIskaznicaPaymentSelectData: [
        { id: 'all', name: 'All' },
        { id: 'kulturnaIskaznica', name: 'Kulturna iskaznica' },
      ],
    }
  },
  computed: {
    statisticsPeriodEndDate() {
      const eventEnd = moment(this.eventTo)

      return (eventEnd.isValid() && eventEnd.isBefore(moment()) ? eventEnd : moment()).format('YYYY-MM-DD')
    },
    allTimeDateRange() {
      const start = moment(this.salesPeriodStartDate)
      const end = moment(this.statisticsPeriodEndDate)

      if (!start.isValid() || start.isAfter(end)) return [end.toDate(), end.toDate()]

      return [start.startOf('day').toDate(), end.endOf('day').toDate()]
    },
    totalTicketsSoldInSelectedRange() {
      const total = sumBy(this.ticketsSoldByDayChartData.datasets, dataset => {
        return sum(dataset.data)
      })

      return total.toString()
    },
    totalEarningsInSelectedRange() {
      const totalEarnings = sumBy(this.earningsChartData.datasets, dataset => {
        return sum(dataset.data)
      })

      return `${round(totalEarnings, 2)} €`
    },
    citySalesBarChartData() {
      const rows = (this.ticketsSoldByCityData || [])
        .filter(item => item && item.ticketsSold > 0)
        .sort((a, b) => b.ticketsSold - a.ticketsSold)
        .slice(0, 7)

      return {
        labels: rows.map(item => item.city || item.postalCode || 'Unknown'),
        datasets: [
          {
            data: rows.map(item => Number(item.ticketsSold) || 0),
            tooltipLabels: rows.map(item => {
              const label = item.city || item.postalCode || 'Unknown'

              return `${label}|${item.ticketsSold}`
            }),
          },
        ],
      }
    },
    hasCitySalesData() {
      return (
        this.citySalesBarChartData &&
        this.citySalesBarChartData.datasets &&
        this.citySalesBarChartData.datasets[0] &&
        this.citySalesBarChartData.datasets[0].data.length > 0
      )
    },
  },
  watch: {
    performanceSelectModel: function (value) {
      this.selectedEventId = value
      this.selectedOrderItemId = null
      this.ticketSelectModel = null
      if (this.showStatistics) {
        this.statisticsLoading = true
      }
      // Reset totals and refetch when performance changes
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      this.filterByDate()
    },
    ticketSelectModel: function (value) {
      this.selectedOrderItemId = value
      if (this.showStatistics) {
        this.statisticsLoading = true
      }
      // Reset totals and refetch when ticket type changes
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      this.filterByDate()
    },
    ticketSellerSelectModel: function (value) {
      if (value === 'online') {
        this.saleChannelOnline = true
        this.selectedTicketSellerId = null
        this.theaterTicketSellerUserId = null
      } else {
        const selectedTicketSeller = this.ticketSellerSelectData.find(item => item.id === value)
        this.saleChannelOnline = false
        if (selectedTicketSeller && selectedTicketSeller.theaterTicketSellerUser) {
          this.selectedTicketSellerId = null
          this.theaterTicketSellerUserId = selectedTicketSeller.id
          this.totalTicketsSold = 0
          this.totalTicketsReserved = 0
          this.totalTicketsWithPromoSold = 0
          this.filterByDate()

          return
        }
        this.selectedTicketSellerId = value
        this.theaterTicketSellerUserId = null
      }
      if (this.showStatistics) {
        this.statisticsLoading = true
      }
      // Reset totals and refetch when sales channel changes
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      this.filterByDate()
    },
    promoCodesSelectModel: function (value) {
      this.selectedPromoCodeIds = value
    },
    kulturnaIskaznicaPaymentSelectModel: function () {
      if (!this.showStatistics) {
        return
      }
      this.statisticsLoading = true
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      this.filterByDate()
    },
  },
  methods: {
    getPurchaseStatsVariables() {
      return {
        eventId: this.selectedEventId,
        eventTemplateId: this.eventTemplateId,
        orderItemId: this.selectedOrderItemId,
        ticketSellerId: this.selectedTicketSellerId,
        theaterTicketSellerUserId: this.theaterTicketSellerUserId,
        promoCodeIds: this.selectedPromoCodeIds.filter(id => id !== null),
        saleChannelOnline: this.saleChannelOnline,
        kulturnaIskaznicaOnly: this.kulturnaIskaznicaPaymentSelectModel === 'kulturnaIskaznica',
      }
    },
    updateSalesPeriodStartDate(orderItems) {
      const salesStartDates = orderItems
        .map(orderItem => moment(orderItem.from))
        .filter(date => date.isValid())

      this.salesPeriodStartDate = salesStartDates.length
        ? moment.min(salesStartDates).format('YYYY-MM-DD')
        : null
    },
    adjustDateRange(dateRange) {
      let startDate = moment(dateRange[0])
      let endDate = moment(dateRange[1])
      const maximumEndDate = moment(this.statisticsPeriodEndDate)

      if (endDate.isAfter(maximumEndDate, 'day')) {
        const rangeLength = endDate.diff(startDate, 'days')
        endDate = maximumEndDate
        startDate = maximumEndDate.clone().subtract(rangeLength, 'days')
      }

      return { startDate: startDate.format('YYYY-MM-DD'), endDate: endDate.format('YYYY-MM-DD') }
    },
    changeTotalTicketsDateRange(dateRangeObject) {
      this.statisticsLoading = true
      const { startDate, endDate } = this.adjustDateRange(dateRangeObject.dateRange)
      this.startDate = startDate
      this.endDate = endDate
      // Keep earnings range in sync with tickets range
      this.earningsStartDate = this.startDate
      this.earningsEndDate = this.endDate
      // Reset totals while awaiting fresh data
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      this.filterByDate()
    },

    changeEarningsDateRange(dateRangeObject) {
      // kept for compatibility; delegate to unified handler
      this.changeTotalTicketsDateRange(dateRangeObject)
    },

    loadCitySales() {
      this.showCitySales = true
      this.resetCityMapState()
      this.$apollo.queries.getPurchasesByEventCityStats.refetch()
    },
    async filterByDate() {
      this.statisticsLoading = true
      if (this.showCitySales) this.resetCityMapState()
      try {
        const queries = [this.$apollo.queries.getPurchasesByEvent2.refetch()]
        if (this.showCitySales) queries.push(this.$apollo.queries.getPurchasesByEventCityStats.refetch())
        await Promise.all(queries)
      } finally {
        this.statisticsLoading = false
      }
    },

    async handleAllPromoCodesSelection(selectedPromoCodes) {
      this.statisticsLoading = true
      if (
        (selectedPromoCodes.includes(null) && !this.selectedPromoCodeIds.includes(null)) ||
        (!this.selectedPromoCodeIds.includes(null) &&
          isEqual(
            selectedPromoCodes.sort(),
            this.promoCodesSelectData
              .map(item => item.id)
              .filter(id => id !== null)
              .sort(),
          ))
      ) {
        this.promoCodesSelectModel = this.promoCodesSelectData.map(item => item.id)
      } else if (!selectedPromoCodes.includes(null) && this.selectedPromoCodeIds.includes(null)) {
        this.promoCodesSelectModel = []
      } else if (
        selectedPromoCodes.includes(null) &&
        this.selectedPromoCodeIds.includes(null) &&
        !isEqual(selectedPromoCodes.sort(), this.promoCodesSelectData.sort())
      ) {
        this.promoCodesSelectModel = this.promoCodesSelectModel.filter(item => item !== null)
      }

      // Reset totals while awaiting fresh data
      this.totalTicketsSold = 0
      this.totalTicketsReserved = 0
      this.totalTicketsWithPromoSold = 0
      if (this.showCitySales) this.resetCityMapState()
      try {
        const queries = [this.$apollo.queries.getPurchasesByEvent2.refetch()]
        if (this.showCitySales) queries.push(this.$apollo.queries.getPurchasesByEventCityStats.refetch())
        await Promise.all(queries)
      } finally {
        this.statisticsLoading = false
      }
    },
    resetCityMapState() {
      this.cityMapLoading = true
      this.cityMapError = ''
      this.ticketsSoldByCityData = []
      this.cityMapPoints = []
    },
    buildCityMapPoints() {
      return (this.ticketsSoldByCityData || [])
        .filter(item => item && Number(item.ticketsSold) > 0)
        .filter(
          item =>
            String(item.city || '')
              .trim()
              .toLowerCase() !== 'unknown',
        )
        .filter(
          item => Number.isFinite(Number(item.latitude)) && Number.isFinite(Number(item.longitude)),
        )
        .map(item => ({
          city: item.city || item.postalCode || 'Unknown',
          country: item.country || null,
          postalCode: item.postalCode || null,
          ticketsSold: Number(item.ticketsSold) || 0,
          latitude: Number(item.latitude),
          longitude: Number(item.longitude),
        }))
        .map((point, index) => ({
          ...point,
          id: `${point.city || 'city'}-${point.postalCode || ''}-${index}`,
        }))
    },
    handleTotalTicketsSoldClick() {
      this.soldTicketsModalTitle = 'workflowsAll.total_tickets_sold_41fe770'
      this.soldTicketsModalData = {
        labels: ['workflowsAll.regular_4ff1814', 'workflowsAll.booked_13e7a65', 'workflowsAll.promo_e0f4f87'],
        datasets: [
          {
            label: 'workflowsAll.prodane_ulaznice_a4a7df8',
            data: [
              this.totalTicketsSold - this.totalTicketsWithPromoSold,
              this.totalTicketsReserved,
              this.totalTicketsWithPromoSold,
            ],
            backgroundColor: ['#0277BD', '#56A4EF', '#CEE4F2'],
            hoverBackgroundColor: ['#0277BD', '#56A4EF', '#CEE4F2'],
          },
        ],
      }
    },
    handleTotalEarningsClick() {
      this.soldTicketsModalTitle = 'workflowsAll.total_earnings_0f37656'
      this.soldTicketsModalData = {
        labels: ['workflowsAll.regular_4ff1814', 'workflowsAll.promo_e0f4f87'],
        datasets: [
          {
            label: 'workflowsAll.zarada_64f2729',
            tooltipLabels: [
              this.totalEarnings - this.totalPromoCodeEarnings + ' €',
              this.totalPromoCodeEarnings + ' €',
            ],
            data: [this.totalEarnings - this.totalPromoCodeEarnings, this.totalPromoCodeEarnings],
            backgroundColor: ['#0277BD', '#CEE4F2'],
            hoverBackgroundColor: ['#0277BD', '#CEE4F2'],
          },
        ],
      }
    },
    handleCancelledTicketsClick() {
      this.showRefundedTicketsModal = !this.showRefundedTicketsModal
    },
    handleBarClick(event, elements) {
      if (elements[0]) {
        const i = elements[0].index

        this.selectedTicketTypesDate = this.ticketTypesData[i].date

        this.showTicketTypesStatisticsModal = true
      }
    },
    handleBarHover(event, chartElement) {
      if (chartElement.length) {
        event.native.target.style.cursor = 'pointer'
      } else {
        event.native.target.style.cursor = 'default'
      }
    },
    transformHeatmapData(data) {
      this.heatmapData = []
      for (let i = 0; i < 7; ++i) {
        const dataInOneDay = data.filter(item => item.e_dow === i)

        let ticketCountUntilSeven = 0
        for (const dataItem of dataInOneDay) {
          if (dataItem.e_hour <= 7) {
            ticketCountUntilSeven += dataItem.numberOfSoldTickets
          } else {
            this.heatmapData.push({
              x: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][i],
              y: `${String(dataItem.e_hour).padStart(2, '0')}:00`,
              value: dataItem.numberOfSoldTickets,
            })
          }
        }
        if (ticketCountUntilSeven > 0) {
          this.heatmapData.push({
            x: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][i],
            y: '00:00 - 07:00',
            value: ticketCountUntilSeven,
          })
        }
      }

      this.heatmapGroups = []
      const maxHeatmapValue = Math.max(...this.heatmapData.map(item => item.value))

      if (maxHeatmapValue <= 4) {
        for (let i = 0; i <= maxHeatmapValue; ++i) {
          this.heatmapGroups.push({
            lowerBound: i,
            upperBound: i,
            backgroundColor: heatmapColorsArray[i],
          })
        }
      } else {
        this.heatmapGroups.push({
          lowerBound: 0,
          upperBound: parseInt(maxHeatmapValue / 5, 10),
          backgroundColor: heatmapColorsArray[0],
        })
        for (let i = 1; i < 4; ++i) {
          this.heatmapGroups.push({
            lowerBound: Math.floor((i * maxHeatmapValue) / 5) + 1,
            upperBound: Math.floor(((i + 1) * maxHeatmapValue) / 5),
            backgroundColor: heatmapColorsArray[i],
          })
        }
        this.heatmapGroups.push({
          lowerBound: Math.floor((4 * maxHeatmapValue) / 5) + 1,
          upperBound: null,
          backgroundColor: heatmapColorsArray[4],
        })
      }
    },
    getEventIdsToInclude(performances, orderItems) {
      if (this.selectedEventId) {
        return [this.selectedEventId]
      }

      if (this.selectedOrderItemId) {
        const scopedIds = (orderItems || [])
          .filter(oi => oi.id === this.selectedOrderItemId)
          .map(oi => oi.eventId)

        return Array.from(new Set(scopedIds))
      }

      return (performances || []).map(p => p.id)
    },
    getFilteredOrderItems(orderItems, eventIds) {
      const ids = new Set(eventIds || [])
      let items = (orderItems || []).filter(oi => ids.has(oi.eventId))
      if (this.selectedOrderItemId) {
        items = items.filter(oi => oi.id === this.selectedOrderItemId)
      }

      return items
    },
    buildPerEventMaps(orderItems, performances) {
      const baseCapacityByEvent = {}
      const seatIdsByEvent = {}
      orderItems.forEach(oi => {
        const eid = oi.eventId
        const hasSeats = oi.sectionSeats && oi.sectionSeats.length > 0

        if (hasSeats) {
          if (!seatIdsByEvent[eid]) {
            seatIdsByEvent[eid] = new Set()
          }
          oi.sectionSeats.forEach(seat => seatIdsByEvent[eid].add(seat))
        } else {
          const performance = performances.find(p => p.id === eid)
          baseCapacityByEvent[eid] = performance ? performance.audienceCapacity : oi.initialQuantity
        }
      })
      Object.keys(seatIdsByEvent).forEach(id => {
        baseCapacityByEvent[id] = seatIdsByEvent[id].size
      })

      const additionalCapacityByEvent = {}
      performances.forEach(p => {
        additionalCapacityByEvent[p.id] = p.additionalCapacity || 0
        if (baseCapacityByEvent[p.id] == null) {
          baseCapacityByEvent[p.id] = p.audienceCapacity || 0
        }
      })

      return { baseCapacityByEvent, additionalCapacityByEvent }
    },
    aggregateTotalTicketCount(eventIds, baseCapacityByEvent, additionalCapacityByEvent) {
      return (eventIds || []).reduce((sum, id) => {
        const base = baseCapacityByEvent[id] || 0
        const extra = additionalCapacityByEvent[id] || 0

        return sum + base + extra
      }, 0)
    },
    computeTotalTicketsReserved(ticketsSoldPerDay, orderItems, eventIds) {
      const totalReserved = (ticketsSoldPerDay || []).reduce(
        (sum, day) => sum + Number(day.totalReserved || 0),
        0,
      )

      if (!this.selectedOrderItemId) return totalReserved

      const ids = new Set(eventIds || [])
      const hasSelectedOrderItemInScope = (orderItems || []).some(
        item => item.id === this.selectedOrderItemId && ids.has(item.eventId),
      )

      return hasSelectedOrderItemInScope ? totalReserved : 0
    },
  },

  apollo: {
    getPurchasesByEvent2: {
      query: GET_PURCHASE_BY_EVENT_2,
      variables() {
        return {
          ...this.getPurchaseStatsVariables(),
          ticketsSoldFrom: this.startDate,
          ticketsSoldTo: this.endDate,
          earningsFrom: this.startDate,
          earningsTo: this.endDate,
        }
      },
      manual: true,
      result({ data, loading }) {
        this.statisticsLoading = loading

        if (!loading && !data) {
          return null
        }
        if (!loading && data.getPurchasesByEvent2) {
          const { getPurchasesByEvent2: statistics } = data
          const {
            eventTo,
            totalTicketsSold,
            totalTicketsSoldWithPromoCode,
            totalTicketsReserved,
            totalVisitors,
            totalSubscriptions,
            totalTicketsRefunded,
            ticketsSoldPerDay,
            ticketsSoldPerPromoCode,
            totalEarnings,
            totalPromoCodeEarnings,
            ticketsRevenuePerDay,
            cumulativeTicketsRevenue,
            orderItems,
            ticketSellers,
            promoCodes,
            soldTicketsGroupedByDayAndHour,
            performances,
            hasKulturnaIskaznicaOrders,
          } = statistics

          this.eventTo = eventTo
          this.updateSalesPeriodStartDate(orderItems)
          this.hasKulturnaIskaznicaOrders = hasKulturnaIskaznicaOrders
          if (!hasKulturnaIskaznicaOrders) {
            this.kulturnaIskaznicaPaymentSelectModel = 'all'
          }
          this.performancesSelectData = [
            { id: null, from: 'All performances' },
            ...performances
              .sort((a, b) => new Date(b.from) - new Date(a.from))
              .map(p => {
                return { ...p, from: p.from }
              }),
          ]

          let ticketsSoldPerDayWithGapsFilled = ticketsSoldPerDay
          if (ticketsSoldPerDay && ticketsSoldPerDay.length) {
            const ticketsByDate = new Map(
              ticketsSoldPerDay.map(entry => [moment(entry.date).format('YYYY-MM-DD'), entry]),
            )
            const currentDate = moment(this.startDate, 'YYYY-MM-DD')
            const endDate = moment(this.endDate, 'YYYY-MM-DD')
            const filled = []

            while (currentDate.isSameOrBefore(endDate, 'day')) {
              const key = currentDate.format('YYYY-MM-DD')
              filled.push(
                ticketsByDate.get(key) || {
                  date: key,
                  totalSold: 0,
                  totalReserved: 0,
                  ticketsPromo: 0,
                  promoCodes: [],
                },
              )
              currentDate.add(1, 'day')
            }
            ticketsSoldPerDayWithGapsFilled = filled
          }

          const tooltipLabels = ticketsSoldPerDayWithGapsFilled.map(ticket => {
            return {
              label: { workflowParts: ['', moment(ticket.date).format('D.M'), 'workflowsAll.regular_13e25f1', Number(
                ticket.totalSold - ticket.ticketsPromo,
              ), 'workflowsAll.booked_9ddf9ee', Number(ticket.totalReserved), 'workflowsAll.with_promo_8859bda', Number(
                ticket.ticketsPromo,
              ), 'workflowsAll.in_total_78f1fae', Number(ticket.totalSold - ticket.ticketsPromo) + Number(ticket.ticketsPromo), ''] },
            }
          })
          this.promoCodes = promoCodes
          this.ticketTypesData = ticketsSoldPerDayWithGapsFilled
          this.ticketsSoldByDayChartData = {
            labels: ticketsSoldPerDayWithGapsFilled.map(entry => moment(entry.date).format('D/M')),
            datasets: [
              {
                data: ticketsSoldPerDayWithGapsFilled.map(entry => entry.totalSold - entry.ticketsPromo),
                tooltipLabels: tooltipLabels,
                bgColor: '#0277BD',
                borderColor: '#0277BD',
              },
              {
                data: ticketsSoldPerDayWithGapsFilled.map(entry => entry.totalReserved),
                tooltipLabels: tooltipLabels,
                bgColor: '#56A4EF',
                borderColor: '#56A4EF',
              },
              {
                data: ticketsSoldPerDayWithGapsFilled.map(entry => entry.ticketsPromo),
                tooltipLabels: tooltipLabels,
                bgColor: '#CEE4F2',
                borderColor: '#CEE4F2',
              },
            ],
          }
          this.ticketSelectData = [
            { id: null, name: 'All ticket types' },
            ...orderItems.map(oi => ({
              ...oi,
              name: oi.name,
            })),
          ]
          this.ticketSellerSelectData = [
            { id: null, name: 'All sales channels' },
            { id: 'online', name: 'Online' },
            ...ticketSellers.flatMap(s => {
              if (s.type === 'THEATER') {
                return s.users.map(u => ({
                  name: `${u.firstName} ${u.lastName}`,
                  id: u.id,
                  theaterTicketSellerUser: true,
                }))
              }

              return { name: s.name, id: s.id }
            }),
          ]
          if (!this.promoCodesSelectData.length) {
            this.selectedPromoCodeIds = [null, ...promoCodes.map(item => item.id)]
            this.promoCodesSelectModel = [null, ...promoCodes.map(item => item.id)]
          }
          if (promoCodes.length) {
            this.promoCodesSelectData = [{ id: null, name: 'All promo codes' }, ...promoCodes]
          }

          // Card totals: always overall for selected event(s), independent of date range
          this.totalTicketsSold = totalTicketsSold
          this.totalTicketsReserved = totalTicketsReserved
          this.totalTicketsWithPromoSold = totalTicketsSoldWithPromoCode
          this.totalVisitors = totalVisitors
          this.totalSubscriptions = totalSubscriptions
          const eventIds = this.getEventIdsToInclude(performances, orderItems)
          const filteredOrderItems = this.getFilteredOrderItems(orderItems, eventIds)

          const { baseCapacityByEvent, additionalCapacityByEvent } = this.buildPerEventMaps(
            filteredOrderItems,
            performances,
          )

          this.totalTicketCount = this.aggregateTotalTicketCount(
            eventIds,
            baseCapacityByEvent,
            additionalCapacityByEvent,
          )

          this.totalEarnings = totalEarnings
          this.totalPromoCodeEarnings = totalPromoCodeEarnings

          this.totalTicketCountWithPromoCode = ticketsSoldPerPromoCode.some(item => item.unlimited)
            ? 0
            : ticketsSoldPerPromoCode.reduce((acc, curr) => (acc += curr.initialQuantity), 0)

          this.soldTicketsByPromoCodeData = ticketsSoldPerPromoCode
          this.totalRefundedTicketsCount = totalTicketsRefunded

          const revenueByDate = new Map(
            ticketsRevenuePerDay.map(entry => [moment(entry.date).format('YYYY-MM-DD'), entry]),
          )
          const ticketsRevenuePerDayWithGapsFilled = []
          const currentEarningsDate = moment(this.earningsStartDate, 'YYYY-MM-DD')
          const earningsEndDate = moment(this.earningsEndDate, 'YYYY-MM-DD')

          while (currentEarningsDate.isSameOrBefore(earningsEndDate, 'day')) {
            const key = currentEarningsDate.format('YYYY-MM-DD')
            ticketsRevenuePerDayWithGapsFilled.push(
              revenueByDate.get(key) || { date: key, revenue: 0 },
            )
            currentEarningsDate.add(1, 'day')
          }

          this.earningsChartData = {
            labels: ticketsRevenuePerDayWithGapsFilled.map(entry => moment(entry.date).format('D/M')),
            datasets: [
              {
                label: 'workflowsAll.revenue_eur_55628aa',
                tooltipLabels: ticketsRevenuePerDayWithGapsFilled.map(
                  r => `${moment(r.date).format('D.M')}|${r.revenue} EUR`,
                ),
                data: ticketsRevenuePerDayWithGapsFilled.map(entry => entry.revenue),
                backgroundColor: '#CEE4F2',
                hoverBackgroundColor: '#CEE4F2',
              },
            ],
          }

          this.soldAndAvailableChartData = {
            labels: ['workflowsAll.sold_tickets_9825f4d', 'workflowsAll.booked_tickets_88e434c', 'workflowsAll.available_tickets_3d70760'],
            datasets: [
              {
                label: 'workflowsAll.zarada_64f2729',
                data: [
                  this.totalTicketsSold,
                  this.totalTicketsReserved,
                  this.totalTicketCount - this.totalTicketsSold,
                ],
                backgroundColor: ['#0277BD', '#56A4EF', '#F5F5F5'],
                hoverBackgroundColor: ['#0277BD', '#56A4EF', '#F5F5F5'],
              },
            ],
          }

          this.cumulativeTicketsRevenueChartData = {
            labels: cumulativeTicketsRevenue.map(entry => moment(entry.date).format('D/M')),
            datasets: [
              {
                title: 'workflowsAll.revenue_eur_55628aa',
                tooltipLabels: cumulativeTicketsRevenue.map(
                  entry => `${moment(entry.date).format('D.M')}|${entry.revenue} EUR`,
                ),
                data: cumulativeTicketsRevenue.map(entry => entry.revenue.toFixed(2)),
              },
            ],
          }

          this.transformHeatmapData(soldTicketsGroupedByDayAndHour)

          this.showStatistics = true
        }
      },
    },
    getPurchasesByEventCityStats: {
      query: GET_PURCHASE_BY_EVENT_CITY_STATS,
      variables() {
        return this.getPurchaseStatsVariables()
      },
      skip() {
        return !this.showCitySales
      },
      manual: true,
      result({ data, loading }) {
        if (loading) {
          this.cityMapLoading = true
          this.cityMapError = ''

          return
        }

        this.ticketsSoldByCityData = (data && data.getPurchasesByEventCityStats) || []
        this.cityMapPoints = this.buildCityMapPoints()
        this.cityMapLoading = false
      },
      error() {
        this.ticketsSoldByCityData = []
        this.cityMapPoints = []
        this.cityMapLoading = false
        this.cityMapError = 'workflowsAll.unable_to_load_city_sales_data_at_the_moment_b3724d9'
      },
    },
  },
}
</script>

<style scoped>
.not-available h1 {
  color: #979797;
  line-height: 24px;
  font-weight: 600;
  font-family: 'Raleway';
  font-size: 20px;
  text-align: center;
}
.grid {
  margin-bottom: 34px;
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(450px, 1fr)); */
  grid-gap: 26px;
  min-width: 0;
}
.full-width-row {
  grid-template-columns: 1fr; /* The first row takes up the whole space */
}

.full-width-row > * {
  min-width: 0;
}

.other-rows {
  grid-template-columns: repeat(
    auto-fit,
    minmax(450px, 1fr)
  ); /* Other rows use auto-fit and minmax */
}
.statistics-chart-skeleton {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0;
}
.statistics-chart-skeleton--tickets {
  height: 400px;
}
.statistics-chart-skeleton--earnings,
.statistics-chart-skeleton--line {
  height: 350px;
}
.statistics-chart-skeleton--page {
  margin-bottom: 24px;
}
.statistics-loading-layout {
  width: 100%;
}
.statistics-card-container--loading {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}
.grid h3 {
  text-align: center;
}
.no-stats {
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
}
.statistics-card-container {
  display: flex;
  padding: 1rem;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 24px;
  flex-wrap: wrap;

  border-radius: 1rem;
  background: #f5f5f5;
}
.statistics-card {
  display: flex;
  padding: 1rem;
  gap: 1rem;
  justify-content: space-between;
  align-items: flex-end;
  flex: 1 0 0;

  border-radius: 0.5rem;
  border: 1px solid #fff;
  background: #fff;
}
.statistics-card:hover {
  cursor: pointer;

  border: 1px solid #d9d9d9;
  box-shadow: 0 4px 16px 0 rgba(51, 51, 51, 0.16);
}
.statistic-card-title {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  white-space: nowrap;
}
.statistics-card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}
.total-sold-data {
  display: flex;
  align-items: baseline;
}
.primary-data-style {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.0675rem;
  white-space: nowrap;
  @media screen and (max-width: 860px) {
    font-size: 1.75rem;
  }
}
.secondary-data-style {
  color: #56a4ef;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.0675rem;
  white-space: nowrap;
  @media screen and (max-width: 860px) {
    font-size: 1.75rem;
  }
}
.tertiary-small-data-style {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;

  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  white-space: nowrap;
  @media screen and (max-width: 860px) {
    font-size: 0.75rem;
  }
}

.tertiary-large-data-style {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;

  font-family: Raleway;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  white-space: nowrap;
  @media screen and (max-width: 860px) {
    font-size: 1.75rem;
  }
}
.total-earning-data {
  display: flex;
  align-items: baseline;
  gap: 1rem;
}

.tertiary-data-style {
  color: #ff8875;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.0675rem;
  white-space: nowrap;
  @media screen and (max-width: 860px) {
    font-size: 1.75rem;
  }
}
@media (max-width: 800px) {
  .statistics-card-container {
    flex-direction: column;
  }
  .statistics-card {
    margin: 12px auto !important;
    width: 100% !important;
  }
}
@media (max-width: 500px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  }
}
@media (max-width: 380px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
.wrapper {
  max-width: 1033px;
}
.noDataText {
  height: 175px;
  margin-top: 150px;
  color: grey;
}
.select-inputs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 26px;
}
@media screen and (max-width: 500px) {
  .select-inputs {
    grid-gap: 12px;
  }
}
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }
}
.selection-promo-code-span:not(:first-child)::before {
  content: ', ';
}
.city-sales-layout {
  display: grid;
  grid-template-columns: minmax(220px, 471px) minmax(280px, 1fr);
  gap: 24px;
  align-items: stretch;
}
.city-sales-chart-wrap {
  width: 100%;
  min-height: 360px;
  display: flex;
  align-items: center;
}
.city-sales-chart {
  width: 100%;
}
.city-sales-no-data {
  margin-top: 0;
  height: auto;
}
.city-sales-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}
@media (max-width: 900px) {
  .city-sales-layout {
    grid-template-columns: 1fr;
  }
  .city-sales-chart-wrap {
    min-height: auto;
  }
}
@media (max-width: 500px) {
  .city-sales-chart-wrap {
    min-height: 280px;
  }
}
</style>
